export default __webpack_public_path__ + "static/media/logo_horizontal.01c1cead.png";